import de from '@/locales/de.json';
import en from '@/locales/en.json';
import pt from '@/locales/pt.json';
import pl from '@/locales/pl.json';
import ro from '@/locales/ro.json';
import tr from '@/locales/tr.json';

export type Language = 'de' | 'en' | 'pt' | 'pl' | 'ro' | 'tr';

export interface LanguageOption {
  code: Language;
  label: string;
  flag: string;
  nativeName: string;
}

export const SUPPORTED_LANGUAGES: LanguageOption[] = [
  { code: 'de', label: 'Deutsch', flag: '🇩🇪', nativeName: 'Deutsch' },
  { code: 'en', label: 'English', flag: '🇬🇧', nativeName: 'English' },
  { code: 'pt', label: 'Português', flag: '🇵🇹', nativeName: 'Português' },
  { code: 'pl', label: 'Polski', flag: '🇵🇱', nativeName: 'Polski' },
  { code: 'ro', label: 'Română', flag: '🇷🇴', nativeName: 'Română' },
  { code: 'tr', label: 'Türkçe', flag: '🇹🇷', nativeName: 'Türkçe' },
];

const translations: Record<Language, typeof de> = { de, en, pt, pl, ro, tr };

export function getTranslations(language: Language): typeof de {
  return translations[language] ?? translations.de;
}

export const DEFAULT_LANGUAGE: Language = 'de';

export function detectBrowserLanguage(): Language {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;
  const browserLang = navigator.language?.split('-')[0] as Language;
  const supported = SUPPORTED_LANGUAGES.map(l => l.code);
  return supported.includes(browserLang) ? browserLang : DEFAULT_LANGUAGE;
}
